/**
 * Free-shipping progress bar — live updates + announcement mode.
 *
 * Bars (snippets/free-shipping-bar.liquid) render from the cart on page load; this
 * keeps every [data-fsb] bar in sync when the cart changes without a reload, and
 * switches the announcement strip between:
 *   - empty cart  → the bar is one rotating slide in the announcement marquee
 *   - has items   → the bar becomes the dominant, non-rotating announcement
 *
 * Listens to Horizon's standard cart event, reading the new cart from its promise
 * (falls back to /cart.js). LA is USD, so remaining is formatted $X.XX.
 */
(() => {
  const formatMoney = (cents) => '$' + (Math.max(0, cents) / 100).toFixed(2);

  const updateBar = (bar, total) => {
    const threshold = parseInt(bar.dataset.fsbThreshold, 10) || 0;
    if (!threshold) return;
    const remaining = threshold - total;
    const fill = bar.querySelector('[data-fsb-fill]');
    const msg = bar.querySelector('[data-fsb-msg]');
    if (fill) fill.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
    bar.classList.remove('fsb--empty', 'fsb--progress', 'fsb--qualified');
    if (total <= 0) {
      bar.classList.add('fsb--empty');
      if (msg) msg.textContent = bar.dataset.fsbStart || '';
    } else if (remaining <= 0) {
      bar.classList.add('fsb--qualified');
      if (msg) msg.textContent = bar.dataset.fsbSuccess || '';
    } else {
      bar.classList.add('fsb--progress');
      if (msg) msg.textContent = (bar.dataset.fsbProgress || '').replace('[amount]', formatMoney(remaining));
    }
  };

  // Announcement strip: rotate the bar as one slide when empty, make it dominant
  // (and pause the marquee) once the cart has items.
  const updateMode = (itemCount) => {
    const rotator = document.querySelector('[data-fsb-rotator]');
    const dominant = document.querySelector('[data-fsb-dominant]');
    if (!rotator || !dominant) return;
    const hasItems = itemCount > 0;
    rotator.hidden = hasItems;
    dominant.hidden = !hasItems;
    const slider = rotator.querySelector('announcement-bar-component');
    if (slider) slider.toggleAttribute('paused', hasItems);
  };

  const updateAll = (cart) => {
    if (!cart) return;
    document.querySelectorAll('[data-fsb]').forEach((bar) => updateBar(bar, cart.total_price));
    updateMode(cart.item_count);
  };

  const getCart = async (event) => {
    try {
      const result = await event?.promise;
      if (typeof result?.cart?.total_price === 'number') return result.cart;
    } catch (e) {
      /* fall through */
    }
    try {
      return await fetch('/cart.js').then((r) => r.json());
    } catch (e) {
      return null;
    }
  };

  document.addEventListener('shopify:cart:lines-update', async (event) => {
    updateAll(await getCart(event));
  });
})();
